export default __webpack_public_path__ + "static/media/joy.3cdc87e8.png";